import type {RouteRecordRaw} from "vue-router";

import {EPermissao} from "@/core/type/permissao.type";

export const listaArranqueRoutes: RouteRecordRaw[] = [
    {
        path: "/rli",
        name: "rli",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_PREENCHER_LISTA_ARRANQUE},
        component: () => import("@/modules/listaArranque/pages/PageRLI.vue")
    },
    {
        path: "/lista-arranque",
        name: "lista-arranque",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_LISTA_ARRANQUE_CONSULTAR},
        component: () => import("@/modules/listaArranque/pages/PageListaArranque.vue")
    },
    {
        path: "/lista-arranque/rli",
        name: "lista-arranque-rli",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_APONTAMENTO_RLI_CONSULTAR},
        component: () => import("@/modules/listaArranque/pages/PageListaArranqueRLI.vue")
    },
    {
        path: "/diario-bordo",
        name: "diario-bordo",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_DIARIO_BORDO_CONSULTAR},
        component: () => import("@/modules/listaArranque/pages/PageDiarioBordo.vue")
    },
];
